import RequestMaster from '../RequestMaster'

export default class RequestSeguimientoTrimestralGrupoColegio extends RequestMaster {

    constructor() {
        super()
        this.URL_BASE = this.URL_BASE + '/grupo-colegio/seguimiento-trimestral'
    }
}
